import React from 'react';
import PropTypes from 'prop-types';

import AttachEmailIcon from '@mui/icons-material/AttachEmail';
import ExpandCircleDownIcon from '@mui/icons-material/ExpandCircleDown';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import { Tooltip } from '@mui/material';

import { reverseFormatDate } from '../../../utils/dateFunctions';

const EventContent = ({ eventInfo, onNav, isDisabled = true }) => {
    const {
        participant,
        location,
        appointmentType,
        additionalDetails,
        content,
        timeContent,
        eventType,
        slots,
        filledSlots,
        hasLink,
        displayCommLinks,
        disableCommsEmail,
        repeat,
        repeatUntilDate,
        displayOccurrence,
        isEventUserRestricted
    } = eventInfo.event.extendedProps;

    const renderLinkContent = () => (
        <div className="fc-event-comms-links">
            <Tooltip
                title={disableCommsEmail ? 'No email address' : 'Email Letter'}
                placement="left-start">
                <span
                    className={
                        disableCommsEmail ? 'fc-event-comms-link-disable' : 'fc-event-comms-link'
                    }
                    data-testid="attach_email_icon">
                    <AttachEmailIcon
                        fontSize={'large'}
                        onClick={() => !disableCommsEmail && onNav(eventInfo.event, 'email')}
                    />
                </span>
            </Tooltip>
            <Tooltip title="Print Letter" placement="left-start">
                <span className="fc-event-comms-link">
                    <MailOutlineOutlinedIcon
                        fontSize={'large'}
                        onClick={() => onNav(eventInfo.event, 'letter')}
                    />
                </span>
            </Tooltip>
        </div>
    );

    const renderOccurrenceContent = () => (
        <div>
            {repeat} until {reverseFormatDate(repeatUntilDate)}
        </div>
    );

    const renderEventContent = (displayComms = false, displayRestart = false) => {
        return (
            <div className="fc-event-main-frame">
                {eventInfo.timeText && eventType !== 'hidden' && (
                    <div className="fc-event-time-line">
                        {timeContent && (
                            <>
                                {displayComms && !isDisabled && !isEventUserRestricted && (
                                    <div className="comms-link-content">
                                        <Tooltip
                                            title={renderLinkContent()}
                                            placement="bottom"
                                            leaveDelay={200}>
                                            <ExpandCircleDownIcon />
                                        </Tooltip>
                                    </div>
                                )}
                                {displayRestart && !isDisabled && (
                                    <div className="occurrence-content">
                                        <Tooltip
                                            title={renderOccurrenceContent()}
                                            placement="bottom"
                                            leaveDelay={200}>
                                            <RestartAltIcon />
                                        </Tooltip>
                                    </div>
                                )}
                                <div className="fc-event-time">{timeContent}</div>
                            </>
                        )}
                    </div>
                )}
                <div className="fc-event-title-container">
                    <div className="fc-event-title">
                        {eventType !== 'participant' && (
                            <span className="content-text">{content}</span>
                        )}
                        {appointmentType && <span>{appointmentType}</span>}
                        {slots && <span> - {filledSlots} </span>}
                        {participant && !hasLink && <span> - {participant}</span>}
                        {participant && hasLink && (
                            <>
                                <span> - </span>
                                <span
                                    className={!isEventUserRestricted ? "event-link" : ''}
                                    onClick={!isEventUserRestricted ? () => onNav(eventInfo.event, 'participant') : null}>
                                    {participant}
                                </span>
                            </>
                        )}
                        {eventType === 'participant' && location && <span> - {location} </span>}
                        {additionalDetails && <span> - {additionalDetails} </span>}
                    </div>
                </div>
            </div>
        );
    };

    return timeContent ? (
        <Tooltip title={renderEventContent()} placement="top" leaveDelay={200}>
            {renderEventContent(displayCommLinks, displayOccurrence)}
        </Tooltip>
    ) : (
        <>{renderEventContent()}</>
    );
};

EventContent.propTypes = {
    eventInfo: PropTypes.object,
    onNav: PropTypes.func,
    isDisabled: PropTypes.bool
};

export default EventContent;
